// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2cMhJ","label":"LabeledBox_label__3fAUe"};